
























































import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'

import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'
import { Breadcrumb } from '@/interfaces/breadcrumbs'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppDialog from '@/components/AppDialog.vue'
import { TypedGqlError } from '@/interfaces/error'
import AppTextField from '@/components/AppTextField.vue'
import AppFormItem from '@/components/AppFormItem.vue'
import AppSelector from '@/components/AppSelector.vue'

@Component({
  components: {
    AppBreadcrumbs,
    AppDialog,
    AppTextField,
    AppFormItem,
    AppSelector
  }
})
export default class SubscriptionCycle extends Vue {
  breadcrumbs: Breadcrumb[] = [
    {
      text: '设置'
    },
    {
      text: '征订周期'
    }
  ];

  confirmDialog = false;
  subscriptionCycle = '';
  sYearIdx = -1;
  sHalfYearIdx = -1;

  yearsOptions: string[] = [];
  halfYearsOptions = ['上半年', '下半年'];

  mounted () {
    const date = new Date()
    const year = date.getFullYear()

    this.yearsOptions =
      Array.from({ length: 10 }, (v, i) => year - i + 5).map(v => v.toString())
    this.getPeriodSetting()
  }

  // 确认更改
  async confirm () {
    try {
      const result = await this.$apollo.mutate({
        mutation: gql`
          mutation {
            createOrUpdatePeriodSetting(
              content: "${this.subscriptionCycle}"
            )
          }
        `
      })
      if (result) {
        showNotification({
          msg: '修改成功！',
          type: SnackType.Success
        })
        this.confirmDialog = false
        await this.getPeriodSetting()
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  async getPeriodSetting () {
    try {
      const result = await this.$apollo.query({
        query: gql`
          query {
            findPeriodSetting
          }
        `
      })
      if (result) {
        this.subscriptionCycle = result.data.findPeriodSetting
        const { year, halfYear } = this.splitSubscriptionCycle(this.subscriptionCycle)
        this.sYearIdx = this.yearsOptions.findIndex((item) => item === year)
        this.sHalfYearIdx = this.halfYearsOptions.findIndex((item) => item === halfYear)
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }

  submitForm () {
    if (this.validateForm('form')) {
      this.subscriptionCycle =
        this.yearsOptions[this.sYearIdx] + '年' + this.halfYearsOptions[this.sHalfYearIdx]
      this.confirmDialog = true
    }
  }

  // 表单重置验证
  resetValidation (form: string) {
    (
      this.$refs[form] as Vue & { resetValidation: () => void }
    ).resetValidation()
  }

  // 表单验证
  validateForm (form: string) {
    return (this.$refs[form] as Vue & { validate: () => boolean }).validate()
  }

  // 分割字符串
  splitSubscriptionCycle (str: string) {
    const year = str.slice(0, 4)
    const halfYear = str.slice(5)

    return {
      year,
      halfYear
    }
  }
}
